import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { PlanIntervalType } from '@fitness-force/enum';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'balance-age-bucket',
  templateUrl: './balance-age-bucket.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class BalanceAgeBucketComponent implements OnInit {

  @Input() additionData = new BehaviorSubject(null);
  @Input() columnData  = new BehaviorSubject(null);
  constructor(private cd: ChangeDetectorRef, private translate:TranslateService) { }

  ngOnInit() {
  }

  getData(data:string) {
    const regex = /\d+/;
    let response: string ="";
    const match = data.match(regex);
    if (match) {
      this.translate.get('REPORTS.REPORT_TEMPLATE.COLUMNS.ai_above', {days: parseInt(match[0], 10)}).subscribe((trans) => {
        response= trans;
      });
    }
    return response;
  }

}